//NEW: UI_REVAMP
import { memo } from 'react';
import BetOne2DKeypad from './bet1/BetOne2DKeypad';
import BetOne3DKeypad from './bet1/BetOne3DKeypad';
import { BetTwo2DKeypad } from './bet2/BetTwo2DKeypad';
import { BetTwo3DKeypad } from './bet2/BetTwo3DKeypad';
import { Bet3KeypadBase } from './bet3/Bet3KeypadBase';

const BetNumberSelectors = ({
	activeBetTab,
	activeSiteType,
	swer3Selection,
	ez2Selection,
	onDigitClick,
	onAddToListSwer,
	onAddToListEz,
	onAddToListBet3,
	betting,
	removeBetting,
	removeAllByDigit,
	gameId,
	drawId,
	activeBetType,
	onManualInteract,
	isDisabled,
	isSelectionIncomplete,
}) => {
	const KEYPAD_MAP = {
		bet1: {
			0: () => (
				<BetOne3DKeypad
					selection={swer3Selection}
					onDigitClick={onDigitClick}
					onManualInteract={onManualInteract}
					isDisabled={isDisabled}
					isSelectionIncomplete={isSelectionIncomplete}
				/>
			),
			1: () => (
				<BetOne2DKeypad
					selection={ez2Selection}
					onDigitClick={onDigitClick}
					onManualInteract={onManualInteract}
					isDisabled={isDisabled}
					isSelectionIncomplete={isSelectionIncomplete}
				/>
			),
		},
		bet2: {
			0: () => (
				<BetTwo3DKeypad
					onAddToList={onAddToListSwer}
					betting={betting}
					removeBetting={removeBetting}
					removeAllByDigit={removeAllByDigit}
					gameId={gameId}
					drawId={drawId}
					activeBetType={activeBetType}
					betTab={activeBetTab}
					onManualInteract={onManualInteract}
					isDisabled={isDisabled}
					isSelectionIncomplete={isSelectionIncomplete}
				/>
			),
			1: () => (
				<BetTwo2DKeypad
					onAddToList={onAddToListEz}
					onManualInteract={onManualInteract}
					activeBetType={activeBetType}
					isDisabled={isDisabled}
					isSelectionIncomplete={isSelectionIncomplete}
				/>
			),
		},
		bet3: {
			0: () => (
				<Bet3KeypadBase
					slotCount={3}
					onAddToList={onAddToListBet3}
					onManualInteract={onManualInteract}
					activeBetType={activeBetType}
					isDisabled={isDisabled}
					isSelectionIncomplete={isSelectionIncomplete}
				/>
			),
			1: () => (
				<Bet3KeypadBase
					slotCount={2}
					onAddToList={onAddToListBet3}
					onManualInteract={onManualInteract}
					activeBetType={activeBetType}
					isDisabled={isDisabled}
					isSelectionIncomplete={isSelectionIncomplete}
				/>
			),
		},
	};

	const render = KEYPAD_MAP[activeBetTab]?.[activeSiteType];
	return render ? render() : null;
};

export default memo(BetNumberSelectors);
